import styled from 'styled-components';
import WhatsAppSVG from '../../assets/common/whatsapp-logo.svg';

const WhatsAppIcon = styled(WhatsAppSVG as React.SFC<React.SVGProps<SVGSVGElement>>,)`
  width: ${props => props.width || '3.9rem'};
  height: ${props => props.height || '3.9rem'};
`;

export default WhatsAppIcon;
